<template>
    <div class="stickers">
        <div class="stickers__content">
            <Preview
                :live-preview="livePreview"
            />

            <div class="stickers__controls">
                <div class="stickers__controls-left">
                    <Button
                        type="primary"
                        @click.native="saveBtn"
                        class="da-ga da-ui--color__btn_fill"
                        v-da-ga.click="{Category: 'Stickers', Action: 'action_Sticker_save'}"
                    >
                        {{ $t('stickers.save') }}
                    </Button>

                    <Button
                        style="margin-left: 10px"
                        @click.native="resetBtn"
                        class="da-ga da-ui--color__btn_default"
                        v-da-ga.click="{Category: 'Stickers', Action: 'action_Sticker_cancel'}"
                    >
                        {{ $t('stickers.reset') }}
                    </Button>
                </div>
                <div class="stickers__controls-right">
                    <Switcher
                        v-if="!previewIsLoading && preview['url']"
                        size="mini"
                        type="colorful"
                        left-sign="СКРИНШОТ"
                        right-sign="LIVE-ТРАНСЛЯЦИЯ"
                        :state="livePreview"
                        :handler="toggleBackgroundHandler"
                        class="da-ui--color__switcher"
                    />
                </div>
            </div>
        </div>

        <div class="stickers__sidebar">
            <div class="stickers__sidebar-head">
                <span class="stickers__sidebar-title">{{ $t('stickers.myStickers') }}</span>
            </div>

            <List />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ACTIONS as ACTIONS_STICKERS } from '../../store/stickers'

import Button from '../../components/ui/button'
import Switcher from '../../components/ui/switcher'
import List from './list'
import Preview from './preview'

export default {
    name: 'Stickers',

    components: {
        Button,
        Switcher,
        List,
        Preview,
    },

    data: () => {
        return {
            livePreview: false,
        }
    },

    computed: {
        ...mapGetters({
            preview: 'preview',
            previewIsLoading: 'previewIsLoading',
            widget: 'widget',
            stickers: 'stickers',
        }),
    },

    watch: {
        stickers(val, oldVal) {
            if (oldVal.length === 0 && val.length > 0 && window.document.getElementById('stickers_input').value) {
                JSON.parse( window.document.getElementById('stickers_input').value ).forEach(s => {
                    const sticker = val.filter(_s => _s.sticker.id === +s.id)[0].sticker

                    this.$store.dispatch(ACTIONS_STICKERS.ADD_STICKER, {
                        sticker,
                        opt: {
                            left: s.left,
                            top: s.top,
                            scale: s.scale,
                            angle: s.left,
                        },
                    })
                })
            }
        },
    },

    mounted() {
        this.$store.dispatch(ACTIONS_STICKERS.FETCH_STREAM_PREVIEW)

        // Костыль для сбрасывания состояния стикеров из вне 
        let prevValue = window.document.getElementById('stickers_input').value
        setInterval(() => {
            const value = window.document.getElementById('stickers_input').value
            if (prevValue !== '' && value === '') this.resetBtn()
            prevValue = value
        }, 1000)
    },

    methods: {
        saveBtn() {
            window.document.getElementById('stickers_input').value = JSON.stringify(this.widget.map(s => {
                return {
                    id: s.id,
                    left: s.left,
                    top: s.top,
                    scale: s.scale,
                    angle: s.angle,
                }
            }))

            document.querySelector('.sticker-popup__close-btn').click()
        },

        resetBtn() {
            this.$store.dispatch(ACTIONS_STICKERS.RESET_WIDGET)

            window.document.getElementById('stickers_input').value = ''
        },

        toggleBackgroundHandler() {
            this.livePreview = !this.livePreview
        },
    },
}
</script>

<style lang='scss' scoped>
.stickers {
    background-color: #fff;
    border-radius: 6px;
    overflow: hidden;
    position: relative;
    box-shadow: 0 10px 40px rgba(0, 0, 0, .4);

    &__content {
        padding: 20px;
        margin-right: 380px;
    }

    &__sidebar {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 380px;
        background-color: #f2f2f2;
    }

    &__controls {
        padding: 20px 0 0;
        position: relative;
    }

    &__sidebar-head {
        user-select: none;
        cursor: default;
        font-size: 14px;
        line-height: 1;
        padding: 20px;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
    }

    &__sidebar-title {
        text-transform: uppercase;
        color: rgba(31, 31, 31, 1);
    }

    &__controls {
        display: flex;
        justify-content: space-between;
        align-items: stretch;

        &-left,
        &-right {
            display: flex;
            align-items: center;
        }
    }

}
</style>